export enum DocumentCategory {
  LOI = "LOI",
  IME_REPORTS = "IME REPORTS",
  MEDICAL_RECORDS_AND_REPORTS = "MEDICAL RECORDS AND REPORTS",
  OCCUPATIONAL_REHABILITATION_REPORTS = "OCCUPATIONAL REHABILITATION REPORTS",
  WORK_CAPACITY_CERTIFICATES = "WORK CAPACITY CERTIFICATES",
  MEDICAL_IMAGING = "MEDICAL IMAGING",
  HOSPITAL_RECORDS_AND_REPORTS = "HOSPITAL RECORDS AND REPORTS",
  PATHOLOGY_REPORTS = "PATHOLOGY REPORTS",
  CLAIMS_FORMS = "CLAIMS FORMS",
  MEDICAL_CERTIFICATES = "MEDICAL CERTIFICATES",
  SURGERY_AND_PROCEDURE_REQUESTS = "SURGERY AND PROCEDURE REQUESTS",
  INJURY_MANAGEMENT_PLAN = "INJURY MANAGEMENT PLAN",
  CONSENT_FORMS = "CONSENT FORMS",
  LEGAL_DOCUMENTS = "LEGAL DOCUMENTS",
  FORM_AMS = "FORM AMS",
  CRIMINAL_POLICE_AND_CORRECTIVE = "CRIMINAL, POLICE, AND CORRECTIVE",
  CENTER_LINK_MEDICAL_CERTIFICATE = "CENTER-LINK MEDICAL CERTIFICATE",
  EDUCATIONAL_RECORDS = "EDUCATIONAL RECORDS",
  FACTUAL_INVESTIGATION_REPORT = "FACTUAL INVESTIGATION REPORT",
  IMC_REFERRAL_FORM = "IMC REFERRAL FORM",
  ALLIED_HEALTH_RECOVERY_REQUEST = "ALLIED HEALTH RECOVERY REQUEST",
  SURVEILLANCE_INVESTIGATIONS = "SURVEILLANCE INVESTIGATIONS",
  GENERAL_CORRESPONDENCE_AND_MISCELLANEOUS_DOCUMENTS = "GENERAL CORRESPONDENCE AND MISCELLANEOUS DOCUMENTS",
}

export const DOCUMENT_CLASSIFICATIONS = [
  {
    id: "1",
    title: "Letter of Instruction",
    category: DocumentCategory.LOI,
    descriptions: [
      {
        id: "1",
        value:
          "LOI is a doc file that you will use as a sample to generate your report.",
      },
      { id: "2", value: "You should upload only one template." },
    ],
  },
  {
    id: "2",
    title: "IME Reports",
    category: DocumentCategory.IME_REPORTS,
    descriptions: [
      {
        id: "1",
        value: "IME Reports are doc files used as samples to generate your report.",
      },
      { id: "2", value: "You can upload more than one IME Report." },
    ],
  },
  {
    id: "3",
    title: "Medical Records and Reports",
    category: DocumentCategory.MEDICAL_RECORDS_AND_REPORTS,
    descriptions: [
      {
        id: "1",
        value:
          "Medical Records and Reports are doc files used as samples to generate your report.",
      },
      { id: "2", value: "You can upload more than one Medical Record or Report." },
    ],
  },
  {
    id: "4",
    title: "Occupational Rehabilitation Reports",
    category: DocumentCategory.OCCUPATIONAL_REHABILITATION_REPORTS,
    descriptions: [
      {
        id: "1",
        value:
          "Occupational Rehabilitation Reports are doc files used as samples to generate your report.",
      },
      {
        id: "2",
        value: "You can upload more than one Occupational Rehabilitation Report.",
      },
    ],
  },
  {
    id: "5",
    title: "Work Capacity Certificates",
    category: DocumentCategory.WORK_CAPACITY_CERTIFICATES,
    descriptions: [
      {
        id: "1",
        value:
          "Work Capacity Certificates are doc files used as samples to generate your report.",
      },
      { id: "2", value: "You can upload more than one Work Capacity Certificate." },
    ],
  },
  {
    id: "6",
    title: "Medical Imaging & Investigations",
    category: DocumentCategory.MEDICAL_IMAGING,
    descriptions: [
      {
        id: "1",
        value:
          "Medical Imaging & Investigations documents are used as samples to generate your report.",
      },
      {
        id: "2",
        value:
          "You can upload more than one Medical Imaging & Investigations document.",
      },
    ],
  },
  {
    id: "7",
    title: "Hospital Records and Reports",
    category: DocumentCategory.HOSPITAL_RECORDS_AND_REPORTS,
    descriptions: [
      {
        id: "1",
        value:
          "Hospital Records and Reports are doc files used as samples to generate your report.",
      },
      { id: "2", value: "You can upload more than one Hospital Record or Report." },
    ],
  },
  {
    id: "8",
    title: "Pathology Reports",
    category: DocumentCategory.PATHOLOGY_REPORTS,
    descriptions: [
      {
        id: "1",
        value:
          "Pathology Reports are doc files used as samples to generate your report.",
      },
      { id: "2", value: "You can upload more than one Pathology Report." },
    ],
  },
  {
    id: "9",
    title: "Claims Forms",
    category: DocumentCategory.CLAIMS_FORMS,
    descriptions: [
      {
        id: "1",
        value: "Claims Forms are doc files used as samples to generate your report.",
      },
      { id: "2", value: "You can upload more than one Claims Form." },
    ],
  },
  {
    id: "10",
    title: "Medical Certificates",
    category: DocumentCategory.MEDICAL_CERTIFICATES,
    descriptions: [
      {
        id: "1",
        value:
          "Medical Certificates are doc files used as samples to generate your report.",
      },
      { id: "2", value: "You can upload more than one Medical Certificate." },
    ],
  },
  {
    id: "11",
    title: "Surgery and Procedure Requests",
    category: DocumentCategory.SURGERY_AND_PROCEDURE_REQUESTS,
    descriptions: [
      {
        id: "1",
        value:
          "Surgery and Procedure Requests are doc files used as samples to generate your report.",
      },
      {
        id: "2",
        value: "You can upload more than one Surgery or Procedure Request.",
      },
    ],
  },
  {
    id: "12",
    title: "General Correspondence and Miscellaneous Documents",
    category: DocumentCategory.GENERAL_CORRESPONDENCE_AND_MISCELLANEOUS_DOCUMENTS,
    descriptions: [
      {
        id: "1",
        value:
          "General Correspondence and Miscellaneous Documents are doc files used as samples to generate your report.",
      },
      {
        id: "2",
        value:
          "You can upload more than one General Correspondence or Miscellaneous Document.",
      },
    ],
  },
  {
    id: "13",
    title: "Consent Forms",
    category: DocumentCategory.CONSENT_FORMS,
    descriptions: [
      {
        id: "1",
        value:
          "Consent Forms are doc files used as samples to generate your report.",
      },
      { id: "2", value: "You can upload more than one Consent Form." },
    ],
  },
  {
    id: "14",
    title: "Legal Documents",
    category: DocumentCategory.LEGAL_DOCUMENTS,
    descriptions: [
      {
        id: "1",
        value:
          "Legal Documents are doc files used as samples to generate your report.",
      },
      { id: "2", value: "You can upload more than one Legal Document." },
    ],
  },
  {
    id: "15",
    title: "Form AMS",
    category: DocumentCategory.FORM_AMS,
    descriptions: [
      {
        id: "1",
        value: "Form AMS documents are used as samples to generate your report.",
      },
      { id: "2", value: "You can upload more than one Form AMS document." },
    ],
  },
  {
    id: "16",
    title: "Criminal, Police, and Corrective",
    category: DocumentCategory.CRIMINAL_POLICE_AND_CORRECTIVE,
    descriptions: [
      {
        id: "1",
        value:
          "Criminal, Police, and Corrective documents are used as samples to generate your report.",
      },
      {
        id: "2",
        value:
          "You can upload more than one Criminal, Police, or Corrective document.",
      },
    ],
  },
  {
    id: "17",
    title: "Center-link Medical Certificate",
    category: DocumentCategory.CENTER_LINK_MEDICAL_CERTIFICATE,
    descriptions: [
      {
        id: "1",
        value:
          "Center-link Medical Certificates are doc files used as samples to generate your report.",
      },
      {
        id: "2",
        value: "You can upload more than one Center-link Medical Certificate.",
      },
    ],
  },
  {
    id: "18",
    title: "Educational Records",
    category: DocumentCategory.EDUCATIONAL_RECORDS,
    descriptions: [
      {
        id: "1",
        value:
          "Educational Records are doc files used as samples to generate your report.",
      },
      { id: "2", value: "You can upload more than one Educational Record." },
    ],
  },
  {
    id: "19",
    title: "Factual Investigation Report",
    category: DocumentCategory.FACTUAL_INVESTIGATION_REPORT,
    descriptions: [
      {
        id: "1",
        value:
          "Factual Investigation Reports are doc files used as samples to generate your report.",
      },
      {
        id: "2",
        value: "You can upload more than one Factual Investigation Report.",
      },
    ],
  },
  {
    id: "20",
    title: "IMC Referral Form",
    category: DocumentCategory.IMC_REFERRAL_FORM,
    descriptions: [
      {
        id: "1",
        value:
          "IMC Referral Forms are doc files used as samples to generate your report.",
      },
      { id: "2", value: "You can upload more than one IMC Referral Form." },
    ],
  },
  {
    id: "21",
    title: "Allied Health Recovery Request",
    category: DocumentCategory.ALLIED_HEALTH_RECOVERY_REQUEST,
    descriptions: [
      {
        id: "1",
        value:
          "Allied Health Recovery Requests are doc files used as samples to generate your report.",
      },
      {
        id: "2",
        value: "You can upload more than one Allied Health Recovery Request.",
      },
    ],
  },
  {
    id: "22",
    title: "Surveillance Investigations",
    category: DocumentCategory.SURVEILLANCE_INVESTIGATIONS,
    descriptions: [
      {
        id: "1",
        value:
          "Surveillance Investigations are doc files used as samples to generate your report.",
      },
      { id: "2", value: "You can upload more than one Surveillance Investigation." },
    ],
  },
  {
    id: "23",
    title: "Injury Management Plan",
    category: DocumentCategory.INJURY_MANAGEMENT_PLAN,
    descriptions: [
      {
        id: "1",
        value:
          "Injury Management Plans are doc files used as samples to generate your report.",
      },
      { id: "2", value: "You can upload more than one Injury Management Plan." },
    ],
  },
];
